var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarValet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.4 0 4 1 3.3 2.4L1.4 6.9C0.5 7.6 0 8.7 0 9.9V15.9C0 16.9 0.7 17.8 1.7 18C2.9 18.2 4 17.2 4 16V15.7C4 15.7 7.3 16 11 16C14.7 16 18 15.7 18 15.7V15.9C18 16.9 18.7 17.8 19.7 18C21 18.2 22 17.2 22 16V9.9C22 8.7 21.5 7.6 20.6 6.8L18.7 2.4C18.1 1 16.6 0 15 0H7ZM7 2H15C15.8 2 16.5 2.5 16.8 3.2L17.9 5.7C16.5 5.3 14.3 5 11 5C7.7 5 5.5 5.3 4.1 5.7L5.2 3.2C5.5 2.5 6.2 2 7 2ZM3.5 9C4.3 9 5 9.7 5 10.5C5 11.3 4.3 12 3.5 12C2.7 12 2 11.3 2 10.5C2 9.7 2.7 9 3.5 9ZM9 9H13C13.6 9 14 9.4 14 10C14 10.6 13.6 11 13 11H9C8.4 11 8 10.6 8 10C8 9.4 8.4 9 9 9ZM18.5 9C19.3 9 20 9.7 20 10.5C20 11.3 19.3 12 18.5 12C17.7 12 17 11.3 17 10.5C17 9.7 17.7 9 18.5 9Z",
    fill: "#787E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarValet);
export default __webpack_public_path__ + "static/media/car-valet.eb3cfd7eb02e1777f8cc5111bb93b609.svg";
export { ForwardRef as ReactComponent };